import(/* webpackMode: "eager" */ "/codebuild/output/src2315228166/src/apps/webapp/src/app/global-error.tsx");
